import {useNavigate} from 'react-router-dom'
import {createExpressOnboarding, getCountry, getLocation, state} from '../core/_requests'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import {useEffect, useRef, useState} from 'react'
import {useAuth} from '../../auth'
import {verifyToken} from '../../auth/core/_requests'
// import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {CountryModel, StateModel} from '../core/_models'
import {GTMEvent, loginSuccessMeta} from '../../../hooks/gtmHelpers'
import TagManager from 'react-gtm-module'
import lottie from 'lottie-web'
import animationData from '../../../../media/auth/loader-anim.json'
import {parseJsonString, removeNullFields} from '../../../core/_util'

export const ExpressOnboarding = () => {
  const navigate = useNavigate()
  const [ipStackData, setIpStackData] = useState<any>()
  const {formatMessage} = useIntl()
  const {
    storeCompanyId,
    setCurrentUser,
    setNewCompany,
    currentUser,
    setCompanyQueuePosition,
    companyId,
    setUseCase,
  } = useAuth()
  const [countryId, setCountryId] = useState<string>()
  const [stateId, setStateId] = useState<string>()
  const planName = localStorage.getItem('plan')
  const inviteCode = localStorage.getItem('inviteCode')
  const useCase = localStorage.getItem('usecase')
  const forClientUse = localStorage.getItem('forClientUse')
  const teamSize = localStorage.getItem('teamSize')
  const industry = localStorage.getItem('industry')
  const heardAboutUs = localStorage.getItem('heardAboutUs')
  const localStorageUtmSource = localStorage.getItem('utm_source') || ''
  const localStorageUtmMedium = localStorage.getItem('utm_medium') || ''
  const localStorageUtmCampaign = localStorage.getItem('utm_campaign') || ''
  const localStorageUtmContent = localStorage.getItem('utm_content') || ''
  const localStorageUtmTerm = localStorage.getItem('utm_term') || ''
  const localStorageGclid = localStorage.getItem('rk_gclid') || ''

  const isRecordskeeper = process.env.REACT_APP_BRAND === 'RK'

  const expressOnboarding = async () => {
    const isEOEnabled =
      localStorage.getItem('eo') ?? process.env.REACT_APP_EXPRESS_ONBOARDING_ENABLED

    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.OnboardingInitiatedSuccessful,
        metadata: removeNullFields({
          express_onboarding: isEOEnabled === 'true' ? true : false,
          email: localStorage.getItem('email') || '',
          country_name: ipStackData?.country_name || 'NA',
          region_name: ipStackData?.region_name || 'NA',
          city_name: ipStackData?.city || 'NA',
          postcode: ipStackData?.zip || 111111,
          utm_source: parseJsonString(localStorageUtmSource),
          utm_medium: parseJsonString(localStorageUtmMedium),
          utm_campaign: parseJsonString(localStorageUtmCampaign),
          utm_content: parseJsonString(localStorageUtmContent),
          utm_term: parseJsonString(localStorageUtmTerm),
          gclid: parseJsonString(localStorageGclid),
        }),
      },
    })

    try {
      const {
        data: {success, data, errors},
      } = await createExpressOnboarding(
        +countryId!,
        +stateId!,
        ipStackData?.city || 'Manhattan',
        +ipStackData?.zip || 10020,
        planName!,
        inviteCode || '',
        useCase || '',
        forClientUse === 'true',
        Number(teamSize),
        industry || '',
        heardAboutUs || ''
      )
      if (success) {
        setNewCompany(undefined)

        const {
          data: {success, data: value},
        } = await verifyToken(data.token)
        if (success) {
          setCurrentUser({...value})
          storeCompanyId(data.companyId)
          setCompanyQueuePosition(data.queuePosition)
          setUseCase(data.useCase)
          const findCompany = currentUser?.company.find(
            (company: {companyId: number}) => company.companyId === companyId
          )
          if (findCompany?.queuePosition > 0) {
            if (planName) {
              const existingPlanComponents = planName.split('-')
              existingPlanComponents[0] = 'Basic'
              const newPlan = existingPlanComponents.join('-')
              localStorage.setItem('plan', newPlan)
            }
          }
          localStorage.removeItem('usecase')
          localStorage.removeItem('countryDialingCode')
          localStorage.removeItem('phoneNumber')
          localStorage.removeItem('email')
          localStorage.removeItem('userId')
        }

        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.OnboardingCompletedSuccessful,
            metadata: removeNullFields({
              express_onboarding: isEOEnabled === 'true' ? true : false,
              country_name: ipStackData?.country_name || 'NA',
              region_name: ipStackData?.region_name || 'NA',
              city_name: ipStackData?.city || 'NA',
              postcode: ipStackData?.zip || 111111,
              ...loginSuccessMeta(value, data.planId, data.itemPrice),
            }),
          },
        })

        setTimeout(() => {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.LoginSuccess,
              metadata: removeNullFields({
                country_name: ipStackData?.country_name || 'NA',
                region_name: ipStackData?.region_name || 'NA',
                city_name: ipStackData?.city || 'NA',
                postcode: ipStackData?.zip || 111111,
                ...loginSuccessMeta(value, data.planId),
              }),
            },
          })
        }, 300)

        // if (!data?.useCase && isRecordskeeper) {
        //   navigate('/manage-records')
        // } else {
        //   navigate('/dashboard')
        // }
        navigate('/dashboard')
      } else {
        if (errors[0].toString() === 'Phone is not verified' && isRecordskeeper) {
          if (data) {
            localStorage.setItem('email', data.email)
            localStorage.setItem('userId', data.userId)
          }
          navigate(`/auth/info`)
        }
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.OnboardingCompletedFailed,
            action: 'normal',
            metadata: removeNullFields({
              express_onboarding: isEOEnabled === 'true' ? true : false,
              country_name: ipStackData?.country_name || 'NA',
              region_name: ipStackData?.region_name || 'NA',
              city_name: ipStackData?.city || 'NA',
              postcode: ipStackData?.zip || 111111,
              ...loginSuccessMeta(currentUser),
            }),
          },
        })

        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (countryId && stateId) {
      expressOnboarding()
    }
  }, [stateId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      (!currentUser?.countryDialingCode && isRecordskeeper) ||
      (!currentUser?.contact && isRecordskeeper) ||
      (!currentUser?.contactVerifiedAt && isRecordskeeper)
    ) {
      navigate('/auth/info/')
    } else {
      const fetchCountry = async () => {
        try {
          const [
            ipStackData,
            {
              data: {data: countries},
            },
          ] = await Promise.all([getLocation(), getCountry()])
          setIpStackData(ipStackData.data)
          const country = countries.find(
            (country: CountryModel) => country.country_code === ipStackData.data.country_code
          )
          if (country) {
            setCountryId(country.countryId)
          }
        } catch (err) {
          console.log(err)
        }
      }
      fetchCountry()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchState = async () => {
      try {
        if (!countryId) {
          return
        }
        const [
          ipStackData,
          {
            data: {data: stateApi, success},
          },
        ] = await Promise.all([getLocation(), state(countryId!)])
        if (success) {
          const state = stateApi.find(
            (state: StateModel) => state.state_name === ipStackData.data.region_name
          )
          if (state) {
            setStateId(state.stateId)
          }
        }
      } catch (err) {}
    }
    fetchState()
  }, [countryId]) // eslint-disable-line react-hooks/exhaustive-deps

  const Lottie = ({animationData}: any) => {
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
      const animation = lottie.loadAnimation({
        container: containerRef.current as Element,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData,
      })

      // Cleanup animation on component unmount
      return () => {
        animation.destroy()
      }
    }, [animationData])

    return <div ref={containerRef} style={{width: '250px', height: '250px', margin: 'auto'}}></div>
  }

  return (
    <>
      <div className='d-flex justify-content-center mb-14'>
        {/* <img
          alt='Loading...'
          src={toAbsoluteUrl('/media/auth/onboarding-loading.svg')}
          className='h-25 w-75'
        /> */}
        <Lottie animationData={animationData} />
      </div>
      <div className='text-center mb-8'>
        <h1 className='text-dark fw-bolder mb-3'>
          {formatMessage({id: 'Setting Up Your Dashboard...'})}
        </h1>
      </div>
      <div className='text-gray-500 fw-semibold fs-6 text-center'>
        {formatMessage({
          id: 'We are taking you to your dashboard.',
        })}
      </div>
      <div className='text-gray-500 fw-semibold fs-6 mb-19 text-center'>
        {process.env.REACT_APP_BRAND === 'FC'
          ? formatMessage({
              id: 'You can start managing your fund raising process immediately',
            })
          : formatMessage({
              id: 'You can start managing your records & data immediately',
            })}
      </div>
    </>
  )
}
